import { AMPLITUDE_EVENT } from '@sonar-software/sonar-analytics';
import { SyncEntry } from './SyncEntry';
import { useAmplitude } from '@hooks';
import React, { useCallback } from 'react';
export const SyncList = ({ syncs }) => {
    const log = useAmplitude();
    const handleClick = useCallback(() => log(AMPLITUDE_EVENT.LOGS_VIEWED), [log]);
    return (React.createElement(React.Fragment, null, syncs.map((sync) => React.createElement(SyncEntry, { key: sync.id, onClick: handleClick, sync: sync }))));
};
